import React, { Component } from "react";
import styled from "styled-components";
import {
  studentPaymentData,
  studentAppointmentData,
  studentBalanceData
} from "../../data/loaders";
import {
  ProcessPaymentData,
  ProcessCancelledAppointments,
  ProcessBalanceData
} from "../../data/process";
import StudentTable from "../core/StudentTable";
import PaymentHeader from "../core/PaymentHeader";
import MustPay from "../core/MustPay";
import BackButton from "../core/BackButton";

import { PageWrapper } from "./LessonDashboard";
import SectionHeader from "../core/style/SectionHeader";
const paymentHeaders = [
  "Receipt #",
  "Date",
  "Amount",
  "Reason For Payment",
  "Payment Type",
  "Notes"
];
const lessonHeaders = [
  "Lesson Date",
  "Lesson Day",
  "Lesson Time",
  "Scheduled Date",
  "Lesson Status",
  "Location",
  "Date Cancelled",
  "Time Cancelled",
  "Amount"
];

const MakePayment = styled.a`
  width: 169px;
  height: 50px;
  border-radius: 3px;
  background-color: #2acae0;
  color: white;
  display: block;
  white-space: nowrap;
  text-align: center;
  line-height: 50px;
  font-weight: 700;
  margin: 0 auto;

  &:hover {
    color: white;
  }
`;

class PaymentDashboard extends Component {
  state = {
    data: {
      paymentData: { header: null, payments: null },
      lessonData: null
    },
    loading: true,
    error: ""
  };
  async componentDidMount() {
    this.props.updateMenu("payments", "Payment / Balances");
    const apiData = await studentPaymentData();
    const balanceApiData = await studentBalanceData();
    const balanceData = ProcessBalanceData(balanceApiData);
    const paymentData = ProcessPaymentData(apiData);

    const apiLessonData = await studentAppointmentData();
    const lessonData = ProcessCancelledAppointments(apiLessonData);

    this.setState({
      data: { paymentData, balanceData, lessonData },
      loading: false
    });
  }
  render() {
    const { data, loading } = this.state;
    if (loading) return <h3>Loading Payment Data.</h3>;

    return (
      <PageWrapper>
        <BackButton path="/app/student-dashboard" />
        <PaymentHeader header={data.balanceData[0]} />
        <MustPay
          header="Balance Owed"
          pay={
            data.balanceData.length > 0 ? data.balanceData[0].Balance : "$0.00"
          }
        />
        <MakePayment href="/pay-balance-form">Make Payment</MakePayment>
        <SectionHeader>Payments</SectionHeader>
        {data.paymentData.length > 0 ? (
          <StudentTable headers={paymentHeaders} data={data.paymentData} />
        ) : (
          <p>No Payment data available.</p>
        )}
        <SectionHeader>Penalties</SectionHeader>
        {data.lessonData.length > 0 ? (
          <StudentTable headers={lessonHeaders} data={data.lessonData} />
        ) : (
          <p>No Penalties available.</p>
        )}
      </PageWrapper>
    );
  }
}

export default PaymentDashboard;
